export interface JWTPayload {
  exp: number
}

export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000

export const decodeJWT = (token: string): JWTPayload | null => {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) {
      return null
    }

    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')

    while (base64.length % 4) {
      base64 += '='
    }

    const decoded = atob(base64)
    return JSON.parse(decoded) as JWTPayload
  } catch {
    return null
  }
}

export const getTimeUntilExpiration = (exp: number): number => {
  const now = Math.floor(Date.now() / 1000)
  const expirationTime = exp
  return (expirationTime - now) * 1000
}

export const getTokenRefreshCheckInterval = (
  timeUntilExpiration: number
): number => {
  const oneHourInMs = 60 * 60 * 1000
  const fiveMinutesInMs = 5 * 60 * 1000
  const sixHoursInMs = 6 * 60 * 60 * 1000
  const oneMinuteInMs = 60 * 1000

  if (timeUntilExpiration > ONE_DAY_IN_MS) {
    const timeUntilOneDayRemaining = timeUntilExpiration - ONE_DAY_IN_MS
    return Math.min(timeUntilOneDayRemaining, sixHoursInMs)
  }

  if (timeUntilExpiration > oneHourInMs) {
    return oneHourInMs
  }

  if (timeUntilExpiration > fiveMinutesInMs) {
    return fiveMinutesInMs
  }

  return Math.max(timeUntilExpiration / 2, oneMinuteInMs)
}
